import IconChevronRightSmall from '@picsart/icons/IconChevronRightSmall';
import cls from 'classnames';
import { JsonLd } from 'react-schemaorg';
import { BreadcrumbList } from 'schema-dts';
import { useEffect, useState } from 'react';

import { Dropdown, DropdownItem } from '../form';

import { IBreadcrumb, IBreadcrumbProps } from './types';
import useStyles from './styles';

const FIRST_INDEX = 0;
const SECOND_INDEX = 1;
const MAX_SUBLINKS_TO_DISPLAY = 4;

export default function Breadcrumb({ items, whiteText = false, className }: IBreadcrumbProps) {
  const classes = useStyles({ whiteText });
  const lastItemIndex = items.length - 1;
  const [indexToDisplay, setIndexToDisplay] = useState(SECOND_INDEX);
  const [dropdownItems, setDropdownItems] = useState<IBreadcrumb[]>([]);
  useEffect(() => {
    items.length > MAX_SUBLINKS_TO_DISPLAY && setIndexToDisplay(lastItemIndex - 1);
    setDropdownItems(items.slice(1, lastItemIndex - 1));
  }, [items, lastItemIndex]);

  const renderAllSubLinks = () => {
    return items.map((item, i) => (
      <li className={classes.item} key={`bc-${i}`}>
        {i === lastItemIndex ? (
          <span className={classes.underlineText}>{item.text}</span>
        ) : (
          <>
            <a className={cls(classes.link)} href={item.href}>
              <span>{item.text}</span>
            </a>
            <IconChevronRightSmall className={classes.icon} />
          </>
        )}
      </li>
    ));
  };

  const renderSubLinksPartially = () => {
    return items.map(
      (item, i) =>
        (i == FIRST_INDEX || i >= indexToDisplay) && (
          <li className={classes.item} key={`bc-${i}`}>
            {i === lastItemIndex ? (
              <span className={classes.underlineText}>{item.text}</span>
            ) : (
              <>
                {i === FIRST_INDEX ? (
                  <>
                    <a className={cls(classes.link)} href={item.href}>
                      <span>{item.text}</span>
                    </a>
                    <IconChevronRightSmall className={classes.icon} />
                    {renderDropdown()}
                    <IconChevronRightSmall className={classes.icon} />
                  </>
                ) : (
                  <>
                    <a className={cls(classes.link)} href={item.href}>
                      <span>{item.text}</span>
                    </a>
                    <IconChevronRightSmall className={classes.icon} />
                  </>
                )}
              </>
            )}
          </li>
        ),
    );
  };

  const renderDropdown = () => {
    return (
      <Dropdown
        popoverClassName={classes.popoverClass}
        buttonClassName={classes.buttonClass}
        hasBorder={false}
        value=""
        onChange={() => null}
        listboxButton={<span className={classes.listboxButton}>...</span>}
      >
        {dropdownItems.map((item: any) => (
          <DropdownItem key={item.text} value={item.text}>
            <a href={item.href}>{item.text}</a>
          </DropdownItem>
        ))}
      </Dropdown>
    );
  };

  return (
    <div className={className}>
      <ul className={classes.list}>
        {indexToDisplay === 1 ? renderAllSubLinks() : renderSubLinksPartially()}

        {
          <JsonLd<BreadcrumbList>
            item={{
              '@context': 'https://schema.org',
              '@type': 'BreadcrumbList',
              itemListElement: items.map(({ text, href }, i) => ({
                '@type': 'ListItem',
                position: i,
                name: text,
                item: `https://tools.picsart.com${href}`,
              })),
            }}
          />
        }
      </ul>
    </div>
  );
}
